/*
 * @Author: ningbo.kang
 * @Date: 2019-10-25 16:43:18
 * @LastEditors: JikeyChang
 * @LastEditTime: 2022-04-07 11:13:13
 * @FilePath: /template/src/core/bootstrap.js
 * @Description: 描述
 */
import store from '@/store/';

import { frameInRoutes } from '@/router/routes';

// 应用程序事件处理
export function created() {
  store.commit('system/page/init', frameInRoutes);
}

// 应用程序事件处理
export function mounted() {
  // 用户登录后从数据库加载一系列的设置
  store.dispatch('system/user/load');
}

export default function Initializer() {}
